import { cn } from "@/lib/utils";

import Align from "./aligns";
import Bold from "./bold";
import FontPicker from "./font-picker";
import FontSizePicker from "./font-size";
import Italic from "./italic";
import Strikethrough from "./strikethrough";
import TextColorPicker from "./text-color";
import TextHighlight from "./text-highlight";
import Underline from "./underline";

interface Props extends React.ComponentProps<"div"> {
  editorRef: React.RefObject<HTMLDivElement>;
}

const TextStyleControls: React.FC<Props> = ({
  editorRef,
  className,
  ...props
}) => {
  return (
    <div className={cn("flex items-center gap-x-3", className)} {...props}>
      <FontPicker editorRef={editorRef} />
      <FontSizePicker editorRef={editorRef} />
      <Bold editorRef={editorRef} />
      <Italic editorRef={editorRef} />
      <Underline editorRef={editorRef} />
      <Strikethrough editorRef={editorRef} />
      <TextColorPicker editorRef={editorRef} />
      <TextHighlight editorRef={editorRef} />
      <Align editorRef={editorRef} />
    </div>
  );
};

export default TextStyleControls;
